'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fade = void 0;
var $ = require("jquery");
var Fade = /** @class */ (function () {
    function Fade() {
        $(window).on('load scroll', function () {
            var winScroll = $(window).scrollTop();
            var winHeight = $(window).height();
            var scrollPos = winScroll + (winHeight * 0.8);
            $(".bulletFade").each(function () {
                if ($(this).offset().top < scrollPos) {
                    $(this).attr('data-is-active', 'true');
                }
            });
        });
    }
    return Fade;
}());
exports.Fade = Fade;
exports.default = Fade;
